import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default function ProductDetailTag({ children, className }) {
  const classes = classNames('product-detail-tag', 'heading--small', className);
  return <div className={classes}>{children}</div>;
}

ProductDetailTag.propTypes = {
  children: PropTypes.node.isRequired,
};
